module.exports = __webpack_public_path__ + "static/media/mail-1.92539067.svg";